// service request
import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize, } from "rn-responsive-styles";
import ModalAlert from "../common/ModalAlert";
import { getServiceReq } from "../api/serviceRequest";
import ServiceRequestList from "../SubComponents/ServiceRequest/ServiceRequestList";
import { COLORS, FONTS } from "../constant";
import { useLogin } from "../context/loginProvider";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import RootNavigation from "../utilities/RootNavigation";
import CText from "../common/CText";
import CImage from "../common/CImage";
import CButton from "../common/CButton";

export default function ServiceRequest(props) {

  let pathName = "Select Document"
  const url = window.location.pathname?.toLowerCase()
  if (url == "/servicerequest/tagclosure" || url == "/servicerequest/selectvehiclefortagclosure") {
    console.log(url, "location.pathname1")
    pathName = "Tag Closure"
  } else if (url == "/servicerequest/rcupdate") {
    console.log(url, "location.pathname2")
    pathName = "RC Update"
  } else if (url == "/servicerequest/kycupdate") {
    console.log(url, "location.pathname3")
    pathName = "KYC Update"
  } else if (url == "/servicerequest/mobileupdate") {
    console.log(url, "location.pathname4")
    pathName = "Update mobile number"
  }
  const styles = useStyles();
  const { state } = useLocation();
  const [data, setData] = useState({ getServiceRequests: [] });
  console.log(state, useLocation(), data?.getServiceRequests, 'state2')
  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => setOpen(!isOpen);
  const [items, setItem] = useState(["RC Update", "KYC Update", "Update mobile number", "Tag Closure"]);
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(pathName);
  const [searchText, setSearchText] = useState("");
  const [dataArr, setDataArr] = useState([]);
  const [reason, setReason] = useState("");
  const [requestIdData, setRequestIdData] = useState("");
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [rcData, setRcData] = useState(false);
  const [isShowAddress, setisShowAddress] = useState(false);
  const [srDataModal, setSrDataModal] = useState(false);
  const navigate = useNavigate();  


  useEffect(() => {
    // vehicleData();
  }, [selectedItem]);

  useEffect(() => {
    // vehicleData();
    if (selectedItem != "KYC Update") {
      setisShowAddress(false)
    }
  }, [selectedItem]);

  const vehicleData = () => {
    getServiceReq()
      .then((response) => {
        if (response?.data) {
          setData({ getServiceRequests: response.data });
          if (response.data.length) {
            let records = response.data.filter(
              (item) => item?.requestType == "KYC Update"
            );
          }
          setDataArr(response.data);
        } else {
          setData({ getServiceRequests: [] });
        }
      })
      .catch(() => { });
  };

  useEffect(() => {
    if (props.route?.params) {
      setSelectedItem(props.route?.params?.screen);
      setRcData(props.route?.params?.data);
    } else {
      setSelectedItem(pathName);
      setRcData("");
    }
  }, [props.route?.params]);

  const filterData = () => {
    let tempArr = dataArr?.filter((item) => {
      return item.serReqId.includes(searchText);
    });
    setData({ getServiceRequests: tempArr });
  };

  useEffect(() => {
    if (searchText && searchText.length > 2) {
      filterData();
    } else if ((searchText && searchText.length < 2) || searchText == "") {
      // vehicleData();
    }
  }, [searchText]);

  useEffect(() => {
    setSelectedItem(pathName)
  }, [pathName])

  useEffect(() => {
    console.log(requestIdData, 'requestId1')

  }, [requestIdData])

  return (
    <View style={styles.container}>

      <View style={styles.servReqContainer}>
        {selectedItem !== "Tag Closure" &&
          <View style={styles.navWidget}>
            <View >
              <TouchableOpacity style={{ flexDirection: 'row', marginLeft: 10 }} onPress={() => { navigate(-1) }}>
                <CImage.backIcon />
                <CText.tripBenifitText style={{ marginLeft: 6 }}>{'Back'}</CText.tripBenifitText>
              </TouchableOpacity>
            </View>
            <Text style={styles.backTextDesc}>{'Self Service'}</Text>

            <View >
              <TouchableOpacity style={styles.faqBtn} onPress={() => { RootNavigation.navigate("Help") }}>
                <Text style={styles.faqText}>{`FAQ's`}</Text></TouchableOpacity>
            </View>
          </View>
        }
        <View style={styles.SvcRq_Body}>
          <Outlet context={{ serviceRequestList: data?.getServiceRequests }} />
         {selectedItem !== "KYC Update" && selectedItem !== "Tag Closure" && selectedItem !== "RC Update" && selectedItem !== "Update mobile number" 
         ? <View style={{ height: 300 }}>
            <ServiceRequestList navigation={props?.navigation} setRequestIdData={setRequestIdData} setSrDataModal={setSrDataModal} />
          </View>
        : null}
        </View>

      </View>
      {showRejectPopup ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={"Reason For Rejection"}
            message={reason}
            actionButton={"OK"}
            onCloseModal={() => setShowRejectPopup(false)}
          />
        </View>
      ) : null}
      {showLogoutModal ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={"Error"}
            message={global.TimeoutError}
            actionButton={"OK"}
            onCloseModal={() => setIsLoggedIn(false)}
          />
        </View>
      ) : null}
      {srDataModal ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <CText.enterOtpText>{"Request Status"}</CText.enterOtpText>

                <View style={styles.statusCardWidget}>
                  <View style={styles.statusCard}>
                    <CText.usedCarLoanUpto style={styles.statusCardL}> {'Request Type'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardM}> {':'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardR}> {requestIdData[0].requestType} </CText.usedCarLoanUpto>
                  </View>
                  <View style={styles.statusCard}>
                    <CText.usedCarLoanUpto style={styles.statusCardL}> {'Date Raised'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardM}> {':'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardR}> {requestIdData[0].reqDate} </CText.usedCarLoanUpto>
                  </View>
                  <View style={styles.statusCard}>
                    <CText.usedCarLoanUpto style={styles.statusCardL}> {'Request ID'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardM}> {':'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardR}>{requestIdData[0].serReqId}  </CText.usedCarLoanUpto>
                  </View>
                  <View style={styles.statusCard}>
                    <CText.usedCarLoanUpto style={styles.statusCardL}> {'Request Status'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardM}> {':'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardR}>{requestIdData[0].status} </CText.usedCarLoanUpto>
                  </View>
                  <View style={styles.statusCard}>
                    <CText.usedCarLoanUpto style={styles.statusCardL}> {'Remarks'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardM}> {':'} </CText.usedCarLoanUpto>
                    <CText.usedCarLoanUpto style={styles.statusCardRejectText}> {requestIdData[0].remarks} </CText.usedCarLoanUpto>
                  </View>
                </View>
                <View style={{ width: 120, alignSelf: 'center' }}>
                  <CButton title={'Back'} onPress={() => setSrDataModal(false)} />
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
    </View>


  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      marginLeft: 40,
      minHeight: 600,
      width: '90%',
      height:600
    },
    servReqContainer: {
      flexGrow: 1,
      backgroundColor: "#fff",
      borderRadius: 12,
      boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
      borderRadius: 12,
      height: "100%",
    },
    statusCardWidget: {
      width: '70%',
      alignSelf: 'center',
      marginVertical: 20
    },
    statusCard: {
      flexDirection: 'row',
      marginVertical: 10
    },
    statusCardL: {
      width: '45%'
    },
    statusCardM: {
      width: '5%'
    },
    statusCardR: {
      width: '50%'
    },
    statusCardRejectText:{
      width: '50%',
      height:90,
      overflow:'scroll'
    },
    faqBtn: {
      borderRadius: 8,
      borderWidth: 1,
      borderColor: '#25243b',
      paddingHorizontal: 30,
      paddingVertical: 10,
      marginRight: 20
    },
    faqText: {
      fontFamily: 'inter',
      fontSize: 13,
      color: COLORS.black200,
      fontWeight: 'bold'
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "90%",
      height: "100%",
      zIndex: 99999,
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    overlayContentViewStyle: {
      width: 460,
      height: 400,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    navWidget: {
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      zIndex: 5,
      paddingTop: 10,
      paddingLeft: 10,
      height: 70,
      borderRadius: 12,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.06)",
      shadowOffset: {
        width: 0,
        height: 3,
      },
      shadowRadius: 6,
      shadowOpacity: 1,
    },
    backTextDesc: {
      fontFamily: 'Inter',
      fontSize: 16,
      color: COLORS.black200,
      fontWeight: 'bold'
    },
    contentWidget: {
      maxWidth: 1200,
      width: '100%',
      flexDirection: 'row',
    },
    SvcRq_Body: {
      marginTop: 30,
      flexGrow: 1,
      backgroundColor: "#fff",
      borderRadius: 12,
      padding: 20,
      boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
      borderRadius: 12,
      height: "100%",
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    KYCUpd: {
      paddingHorizontal: 20,
    },
  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {
      
    },
    [maxSize(DEVICE_SIZES.MD)]: {
      container: {
        height: 800,
        width:580
      },
      SvcRq_Body: {
        flexDirection: 'column',
        justifyContent: 'flex-start'
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
      SvcRq_Body: {
        flexDirection: 'column'
      },
      navWidget: {
        paddingLeft: 0
      },
      overlayContentViewStyle: {
        width: '98%'
      },
      SvcRq_Body: {
        alignItems: 'center'
      },
    },
    [maxSize(DEVICE_SIZES.XS)]:{
      navWidget: {
        paddingLeft: 0
      },
      faqText: {
        fontSize: 11,
      },
      contentWidget: {
        width: '90%'
      },
      overlayContentViewStyle: {
        width: '98%'
      },
      container: {
        marginHorizontal: 5,
        height: Dimensions.get('window').height
      },
      SvcRq_Body: {
        flexDirection: 'column'
      },

      KYCUpd: {
        paddingHorizontal: 20,
      },
      SvcRq_Body: {
        alignItems: 'center'
      },

    },
  }
);
